<div class="theme-settings">
	<h6 class="title-uppercase">{{ 'SETTINGS_MENU.LANGUAGE' | translate }}</h6>
	<div class="settings-row theme-button">
		<ng-container *ngIf="languages.length">
			<nb-select
				[(selected)]="currentLang"
				[placeholder]="'SETTINGS_MENU.ENGLISH' | translate"
				(selectedChange)="switchLanguage()"
				status="primary"
			>
				<nb-option *ngFor="let lang of languages" [value]="lang.value">
					{{ lang.name | translate }}</nb-option
				>
			</nb-select>
		</ng-container>
	</div>
</div>